<!-- PROGRESS BAR -->
<app-progress-bar />
<!-- / PROGRESS BAR -->
<app-push-notification-banner />

<!-- <app-layout></app-layout> -->
<router-outlet />